import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Row, Col } from "react-bootstrap";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { validateEmail } from "../../../utils/validation/email";
import EzControlledInput from "../../../common/EzForm/EzControlledInput";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import ReCAPTCHA from "react-google-recaptcha";
import "./style.css";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
const CreateCompanyComponent = (props) => {
  const {
    createCompany,
    isLoading,
    isEdit,
    formFieldValueMap,
    shouldBlockNavigation,
    navigateToCompanySummaryScreen,
    isCreateCompnayError,
    isCreateCompanySuccess,
    countries,
    provinces,
    citys,
    onCountryChange,
    onProvinceChange,
    onCityChange,
  } = props

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const onSubmit = (data) => {    
    let payload={
      companyName: data.companyName,
      companyCode: "",
      documentEmail:data.email,
      phone: data.contactNumber,
      address1: data.streetAddress1,
      address2: data.streetAddress2,
      country: data.country,
      state: data.state,
      city: data.city,
      postalCode: data.zipCode,
      email: data.email,
      secondary_email_id: data.secondary_email_id || null,
      businessType: 68,
      subBusiness: null,
      planType: 34,
      validTill: "2030-12-31",
      firstName: data.firstName,
      lastName: data.lastName,
      pwd: data.password
    }

    if (isEdit) {
    }
    else{
    createCompany({
      data: payload,
    })
    }
  };
  const getToastProps = () => {
   
    if (isCreateCompanySuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Customer Company Created Successfully",
        shouldShowToast: true,
      };
    }

    if (isCreateCompnayError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while Creating Customer Company",
        shouldShowToast: true,
      };
    }
    
    else {
      return {
        shouldShowToast: false,
      };
    }
 
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative mb-3">
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div>
              <h4>Add Customer Company</h4>
            </div>
          </div>
          <Button
            tooltip={"Back to Company List"}
            tooltipOptions={{ position: "left" }}
            label={"Back"}
            className={`p-button`}
            onClick={navigateToCompanySummaryScreen}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="form-container">
      <EzToast {...getToastProps()} />
      {renderPageHeaderSection()}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md={6}>
            <EzControlledInput
              name="firstName"
              control={control}
              label="First Name"
              rules={{ required: "First Name is required" }}
              errorMsg={errors.firstName && errors.firstName.message}
              isError={!!errors.firstName}
            />
          </Col>
          <Col md={6}>
            <EzControlledInput
              name="lastName"
              control={control}
              label="Last Name"
              rules={{ required: "Last Name is required" }}
              errorMsg={errors.lastName && errors.lastName.message}
              isError={!!errors.lastName}
            />
          </Col>
        </Row>

        <EzControlledInput
          name="email"
          control={control}
          label="Email"
          type="email"
          rules={{
            ...getFormBaseValidationRule().DEFAULT.VALIDATION_RULE,
            validate: (value) => validateEmail(value) || "Invalid email address",
          }}
          errorMsg={errors.email && errors.email.message}
          isError={!!errors.email}
        />
        <EzControlledInput
          name="secondary_email_id"
          control={control}
          label="Secondary Email"
          type="email"
          rules={{
            validate: (value) => !value || validateEmail(value) || "Invalid email address",
          }}
          errorMsg={errors.secondary_email_id && errors.secondary_email_id.message}
          isError={!!errors.secondary_email_id}
        />

        <Row>
          <Col md={6}>
            <EzControlledInput
              name="password"
              control={control}
              label="Password"
              type="password"
              rules={{ required: "Password is required" }}
              errorMsg={errors.password && errors.password.message}
              isError={!!errors.password}
            />
          </Col>
          <Col md={6}>
            <EzControlledInput
              name="confirmPassword"
              control={control}
              label="Confirm Password"
              type="password"
              rules={{
                required: "Confirm Password is required",
                validate: (value) =>
                  value === getValues("password") || "Passwords do not match",
              }}
              errorMsg={
                errors.confirmPassword && errors.confirmPassword.message
              }
              isError={!!errors.confirmPassword}
            />
          </Col>
        </Row>

        <EzControlledInput
          name="contactNumber"
          control={control}
          label="Contact Number"
          rules={{
            pattern: {
              value: /^[0-9]{10}$/,
              message: "Invalid contact number",
            },
          }}
          errorMsg={errors.contactNumber && errors.contactNumber.message}
          isError={!!errors.contactNumber}
        />

        <EzControlledInput
          name="streetAddress1"
          control={control}
          label="Street Address 1"
        />

        <EzControlledInput
          name="streetAddress2"
          control={control}
          label="Street Address 2"
        />

        <Row>
          <Col md={6}>
            <EzControlledDropDowntWithFloatingLabel
              name="country"
              control={control}
              label="Select Country"
              autocomplete="off"
              options={countries}
              rules={{ required: "Country is required" }}
              errorMsg={errors.country && errors.country.message}
              isError={!!errors.country}
              onChange={(e) => onCountryChange(e.value)}
            />
          </Col>
          <Col md={6}>
            <EzControlledDropDowntWithFloatingLabel
              name="state"
              control={control}
              label="Select State"

              options={provinces}
              rules={{ required: "State is required" }}
              errorMsg={errors.state && errors.state.message}
              isError={!!errors.state}
              onChange={(e) => onProvinceChange(e.value)}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <EzControlledDropDowntWithFloatingLabel
              name="city"
              control={control}
              label="Select City"
              options={citys}
              rules={{ required: "city is required" }}
              errorMsg={errors.city && errors.city.message}
              isError={!!errors.city}
            />
          </Col>
          <Col md={6}>
            <EzControlledInput
              name="zipCode"
              control={control}
              label="Zip/Postal Code"
              errorMsg={errors.zipCode && errors.zipCode.message}
              isError={!!errors.zipCode}
            />
          </Col>
        </Row>
        <EzControlledInput
          name="companyName"
          control={control}
          label="Company Name"
          rules={{ required: "Company Name is required" }}
          errorMsg={errors.companyName && errors.companyName.message}
          isError={!!errors.companyName}
        />

        <div className="form-group mt-3">
          <Button type="submit" className="w-100" label="Create" />
        </div>
      </form>
    </div>
  );
};

export default CreateCompanyComponent;
